import { ON_BLOCKS_MOUNTED } from '../state-constants/stateConstants';

export const onBlocksMounted = (status) => ({
  type: ON_BLOCKS_MOUNTED,
  payload: status,
});



// WEBPACK FOOTER //
// ./src/state-actions/onBlocksMounted.js